<template>
  <div class="header">
    <el-row v-loading="fetching">
      <el-col :span="24" align="center" v-if="!fetching">

        <el-menu v-if="!authenticated" :default-active="$route.name" :router="true" class="hidden-sm-and-down" mode="horizontal">

          <el-menu-item index="">
            <router-link :to="{ name: 'home'}">
              <el-button type="text">
                <img src="@/assets/img/logos/logo-h.png" class="logo horizontal">
              </el-button>
            </router-link>
          </el-menu-item>

          <el-menu-item v-for="(item, index) in menus.noauth.primary" :index="item.name" :route="{ name: item.name }" :key="`primary-noauth-`+index" >
            {{item.label}}
          </el-menu-item>

        </el-menu>

        <el-menu v-if="authenticated" :default-active="$route.name" :router="true" class="hidden-sm-and-down" mode="horizontal">

          <el-menu-item index="">
            <router-link :to="{ name: 'dashboard'}">
              <el-button type="text">
                <img src="@/assets/img/logos/logo-h.png" class="logo horizontal">
              </el-button>
            </router-link>
          </el-menu-item>

          <el-menu-item v-for="(item, index) in menus.auth.primary" :index="item.name" :route="{ name: item.name }" :key="`primary-user-`+index" v-show="hasPermission(item.permission)">
            <header-menu-item :showIcon="true" :icon="item.icon" :label="item.label" :notification="item.notification" :alert="item.alert" :shouldHide="shouldHide(item)"></header-menu-item>
          </el-menu-item>

          <el-submenu index="1" class="float-left" v-auth="['admin', 'manager', 'officeAdmin']">
            <template slot="title">
              <el-badge :value="adminNotification" class="mark" :hidden="adminNotification === 0">
                <i class="fas fa-lock-alt"></i>
                <span class="label">Admin</span>
              </el-badge>
            </template>

            <el-menu-item-group title="Master" v-show="hasPermission('master')">
              <el-menu-item v-for="(item, index) in menus.auth.master" :index="'1-'+index" :route="{ name: item.name }" :key="`master-user-`+index">
                <header-menu-item :icon="item.icon" :label="item.label" :notification="item.notification" :alert="item.alert" :shouldHide="shouldHide(item)" :showTooltip="false"></header-menu-item>
              </el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group title="Management">
              <el-menu-item v-for="(item, index) in menus.auth.admin" :index="'2-'+index" :route="{ name: item.name }" :key="`admin-user-`+index" v-show="hasPermission(item.permission)">
                <header-menu-item :icon="item.icon" :label="item.label" :notification="item.notification" :alert="item.alert" :shouldHide="shouldHide(item)" :showTooltip="false"></header-menu-item>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="user" class="float-right">
            <template slot="title">
              <span v-if="currentUser.profile">
                <img :src="getGravatar(currentUser.email,'20')" class="thumbnail"> {{ currentUser.profile.first_name }} {{ currentUser.profile.last_name }}
              </span>
              <span v-else>
                User
              </span>
            </template>

            <el-menu-item v-for="(item, index) in menus.auth.secondary" :index="item.name" :route="{ name: item.name }" :key="`secondary-user-`+index" v-show="hasPermission(item.permission)">
              <header-menu-item :icon="item.icon" :label="item.label" :notification="item.notification" :alert="item.alert" :shouldHide="shouldHide(item)" :showTooltip="false"></header-menu-item>
            </el-menu-item>

            <el-menu-item index="logout" @click="logoutHandler">
              <header-menu-item icon="fas fa-sign-out-alt" label="Logout" :shouldHide="true" :showTooltip="false"></header-menu-item>
            </el-menu-item>

          </el-submenu>

          <div class="float-right">
            <header-menu-timer :activeTimeLog="activeTimeLog" v-if="activeTimeLog"></header-menu-timer>
          </div>

        </el-menu>

      </el-col>
    </el-row>
  </div>
</template>

<script>
  import avatar from '@/mixins/avatar';
  import { mapGetters, mapActions } from 'vuex';
  import { Loading } from 'element-ui';
  import { intersection } from 'lodash';

  import HeaderMenuItem from '@/components/HeaderMenuItem';
  import HeaderMenuPolicy from '@/components/HeaderMenuPolicy';
  import HeaderMenuTimer from '@/components/HeaderMenuTimer';
  import availableLocales from '@/i18n/available_locales';

  export default {
    name: 'Header',
    components: {
      headerMenuItem: HeaderMenuItem,
      headerMenuTimer: HeaderMenuTimer,
      headerMenuPolicy: HeaderMenuPolicy,
    },
    data() {
      return {
        isCollapse: false,
        locales: availableLocales,
        menus: {
          auth: {
            primary: {
              dashboard: { name: 'dashboard', label: 'Dashboard', icon: 'far fa-tachometer-alt-average', permission: [], notification: 0, alert: false, show: false },
              mytimesheets: { name: 'mytimesheets', label: 'My Timesheets', icon: 'fas fa-user-clock', permission: ['employee', 'manager', 'officeAdmin'], notification: 0, alert: false, show: false },
              myptos: { name: 'myptos', label: 'My PTOs', icon: 'fas fa-island-tropical', permission: ['employee', 'manager', 'officeAdmin'], notification: 0, alert: false, show: false },
              policy: { name: 'policy', label: 'Company Policy', icon: 'fas fa-book-spells', permission: [], notification: 0, alert: false, show: false },
            },
            master: {
              companies: { name: 'companies', label: 'Companies', icon: 'fas fa-building', permission: ['master'], notification: 0, alert: false, show: false },
            },
            admin: {
              clockedin: { name: 'clockedin', label: 'Clocked In', icon: 'far fa-stopwatch', permission: ['admin', 'manager'], notification: 0, alert: false, show: false },
              bmsreport: { name: 'bmsreport', label: 'BMS Report', icon: 'far fa-file-invoice', permission: ['admin', 'manager', 'officeAdmin'], notification: 0, alert: false, show: false },
              payroll: { name: 'payroll', label: 'Payroll', icon: 'far fa-file-invoice', permission: ['admin', 'manager', 'officeAdmin'], notification: 0, alert: false, show: false },
              timesheets: { name: 'timesheets', label: 'Timesheets', icon: 'far fa-calendar-week', permission: ['admin', 'manager', 'officeAdmin'], notification: 0, alert: false, show: false },
              ptos: { name: 'ptos', label: 'PTOs', icon: 'fas fa-island-tropical', permission: ['admin', 'manager', 'officeAdmin'], notification: 0, alert: false, show: false },
              users: { name: 'users', label: 'Users', icon: 'fas fa-users', permission: ['admin', 'manager', 'officeAdmin'], notification: 0, alert: false, show: false },
            },
            secondary: {
              profile: { name: 'profileSettings', label: 'User Profile', icon: 'fas fa-user', permission: [], notification: 0, alert: false, show: false },
              apps: { name: 'appsSettings', label: 'Apps Settings', icon: 'far fa-browser', permission: ['admin'], notification: 0, alert: false, show: false },
            },
          },
          noauth: {
            primary: {
              home: { name: 'home', label: 'Login', icon: 'fas fa-sign-in-alt', notification: 0, alert: false, show: true },
            },
            secondary: {

            },
          },
        },
      };
    },
    mixins: [avatar],
    created() {
      this.refreshNotifications();
    },
    computed: {
      ...mapGetters(['locale']),
      ...mapGetters('entities/apps', ['fetching']),
      ...mapGetters('entities/ptos', ['fetching']),
      ...mapGetters('entities/users', ['authenticated', 'currentUser']),

      activeTimeLog() {
        return this.$store.getters['entities/timeLogs/query']()
          .where(record => record.stopped_at === null)
          .where('deleted', false)
          .where('user_id', this.currentUser.id)
          .first();
      },
      policy() {
        return this.$store.getters['entities/policies/query']().first();
      },
      policyAccepted() {
        return (this.currentUser) ? this.currentUser.policy_accepted_at : null;
      },
      adminNotification() {
        return this.menus.auth.admin.ptos.notification + this.menus.auth.admin.timesheets.notification;
      },
    },
    methods: {
      ...mapActions('entities/users', ['logout']),
      ...mapActions('entities/policies', ['fetchPolicy']),
      ...mapActions('entities/ptos', ['fetchPtos']),
      ...mapActions('entities/timesheets', ['fetchTimesheets']),
      refreshNotifications() {
        if (this.currentUser) {
          if (this.hasPermission('admin')) {
            this.fetchPendingTimesheets();
            this.fetchPendingPtos();
            this.fetchRejectedTimesheets();
          } else if (this.hasPermission('manager')) {
            this.fetchRunningTimeLog();
            this.fetchRejectedTimesheets();
            this.fetchRejectedPtos();
            this.fetchPendingTimesheets();
            this.fetchPendingPtos();
            this.checkPolicy();
          } else if (this.hasPermission('officeAdmin')) {
            this.fetchRunningTimeLog();
            this.fetchRejectedTimesheets();
            this.fetchRejectedPtos();
            this.fetchPendingTimesheets();
            this.fetchPendingPtos();
            this.checkPolicy();
          } else {
            this.fetchRunningTimeLog();
            this.fetchRejectedTimesheets();
            this.fetchRejectedPtos();
            this.checkPolicy();
          }
        }
      },
      hasPermission(permission) {
        const matchPermissions = (intersection(this.currentUser.permissions, (typeof permission === 'string') ? [permission] : permission).length > 0 || permission.length === 0);
        return matchPermissions;
      },
      shouldHide(item) {
        return (item.notification === 0 && item.alert === false);
      },
      logoutHandler() {
        const loader = Loading.service({ fullscreen: true });
        this.$store.dispatch('entities/users/logout')
          .then(() => {
            loader.close();
            this.$router.push({ name: 'home' });
            this.isCollapse = true;
          })
          .catch(() => loader.close());
      },
      checkPolicy() {
        this.fetchPolicy()
          .then((response) => {
            this.menus.auth.primary.policy.show = response.status;
            if (this.currentUser) {
              if (this.currentUser.policy_accepted_at === null && response.status) {
                this.menus.auth.primary.policy.alert = true;
              } else {
                this.menus.auth.primary.policy.alert = false;
              }
            }
          });
      },
      fetchRunningTimeLog() {
        return this.$store.dispatch('entities/timeLogs/fetchRunningTimeLog');
      },
      fetchRejectedTimesheets() {
        this.$store.dispatch('entities/timesheets/fetchRejectedTimesheets', { user_id: this.currentUser.id })
          .then((response) => {
            if (response.status) {
              this.menus.auth.primary.mytimesheets.notification = response.data.entities.length;
            }
          });
      },
      fetchPendingTimesheets() {
        this.$store.dispatch('entities/timesheets/fetchPendingTimesheets', {})
          .then((response) => {
            if (response.status) {
              this.menus.auth.admin.timesheets.notification = response.data.entities.length;
            }
          });
      },
      fetchRejectedPtos() {
        this.$store.dispatch('entities/ptos/fetchRejectedPtos', { user_id: this.currentUser.id })
          .then((response) => {
            if (response.status) {
              this.menus.auth.primary.myptos.notification = response.data.entities.length;
            }
          });
      },
      fetchPendingPtos() {
        this.$store.dispatch('entities/ptos/fetchPendingPtos', {})
          .then((response) => {
            if (response.status) {
              this.menus.auth.admin.ptos.notification = response.data.entities.length;
            }
          });
      },
    },
    watch: {
      policyAccepted() {
        this.checkPolicy();
      },
      currentUser(newValue, oldValue) {
        if (!oldValue && newValue) {
          this.refreshNotifications();
        }
      },
    },
  };
</script>

<style lang="scss">
  @import '../assets/scss/variables';
  .thumbnail{
    max-width: 20px;
    margin-right: 8px;
  }
  .el-badge{
    .el-badge__content{
      top: 12px !important;
      right: 5px;
    }
  }
  .el-header{
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    z-index: 1000;
    height: auto !important;
    padding: 0;
    .header {
      height: inherit;
      background-color: #fff;
      box-shadow: 10px 0px 40px rgba(0,0,0,0.1);
      .logo{
        max-height: 30px;
        display: block;
        padding: 15px 0;
        margin: auto;
        padding: 0;
        &.horizontal{
          max-width: 120px;
          max-height: 15px;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
        }
      }
      .el-menu{
        max-width: 1410px;
        background-color: transparent;
        margin: auto;
        border: 0;
        .el-menu-item{
          border-right: solid 1px #e6e6e6;
          color: #383838;
          &.is-active{
            border-bottom: 2px solid $--saffron-red-delight !important;
          }
          i{
            font-size: 19px;
            color: #383838;
            margin-top: -4px;
          }
          &:hover{
            color: $--saffron-red-delight;
            i{
              color: $--saffron-red-delight;
            }
          }
        }
      }
      .el-submenu{
        i{
          font-size: 19px;
          color: #383838;
          margin-top: -4px;
        }
        .label{
          text-indent: 10px;
          display: inline-block;
        }
      }
    }
  }
  .el-menu-item-group{
    .el-menu-item-group__title{
      padding-left: 20px !important;
    }
    >ul{
      padding: 0 0 0 10px
    }
  }
  .el-menu--popup{
    .el-menu-item{
      i{
        color: #383838;
        width: 30px;
      }
      &:hover{
        i{
          color: #E4A6F0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue